module.exports = __webpack_public_path__ + "img/resource-tech-image-30.20fc8329.jpg";